import { ModalContato } from "../Modal";
import { Container } from "./styles";

export function Mobile() {
  return (
    <Container>
      <div style={{ color: "#464646" }} className="banner-slider-mobile">
        <h3>Deseja otimizar seu atendimento ?</h3>
        <p className="subnome-mobile">
          Entre em contato que vamos te explicar como funciona.
        </p>
        <ModalContato />
        <p className="banner-p-mobile">
          Com chat bot você otimizar seu atendimento deixando um bot pré
          configurado conforme você deseja, 24hrs por dia de domingo a domingo,
          reduzindo seus custos, agilizar atendimento, passando credibilidade e
          aumentando suas vendas.
        </p>
      </div>
    </Container>
  );
}
